var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEveLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 294.2 169.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d78a89;}.cls-2{fill:#d72525;}.cls-3{fill:#c8cfdd;}.cls-4{fill:#8caefa;}.cls-5{fill:#b0c2e9;}.cls-6{fill:#d79494;}.cls-7{fill:#d74d4d;}.cls-8{fill:#d60203;}.cls-9{fill:#d68686;}.cls-10{fill:#8daffa;}.cls-11{fill:#d73131;}.cls-12{fill:#d69898;}.cls-13{fill:#d74646;}.cls-14{fill:#d6d6d6;}.cls-15{fill:#d6bcbc;}.cls-16{fill:#8faef7;}.cls-17{font-size:90px;}.cls-17,.cls-20,.cls-21,.cls-22{font-family:HelveticaNeue-UltraLight, Helvetica Neue;font-weight:100;}.cls-18{fill:none;}.cls-19{font-size:21px;font-family:HelveticaNeue, Helvetica Neue;}.cls-21{letter-spacing:0.02em;}.cls-22{letter-spacing:0em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.38,
    y: 13,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 85.38,
    y: 26,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 98.38,
    y: 13,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 98.38,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 111.38,
    y: 26,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 124.38,
    y: 26,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 137.38,
    y: 13,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 124.38,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 137.38,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 150.38,
    y: 13,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 163.38,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 176.38,
    y: 13,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 176.38,
    y: 26,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 189.38,
    y: 13,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 111.38,
    y: 13,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 202.38,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-17",
    transform: "translate(80.36 106)"
  }, "eve"), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 91.88,
    y1: 88.5,
    x2: 91.88,
    y2: 146.5
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-19",
    transform: "translate(5.98 137.05)"
  }, "e", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 11.28,
    y: 0
  }, "volutiona"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 83.24,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 89.06,
    y: 0
  }, "y model of "), /*#__PURE__*/React.createElement("tspan", {
    x: 182.05,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 192.55,
    y: 0
  }, "ariant "), /*#__PURE__*/React.createElement("tspan", {
    x: 242.32,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 253.59,
    y: 0
  }, "ffect"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEveLogo);
export default __webpack_public_path__ + "static/media/eveLogo.8f32419f.svg";
export { ForwardRef as ReactComponent };